import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';
import { ProgressLinear } from '@mint-lib/tw-components/patterns';
import { cn } from '@mint-lib/tw-utils';

import { AsyncValidationState } from '../../api/types.js';
import { Loader } from '../atoms/Loader.jsx';

type ValidationProgressStateProps = Readonly<{
  validationState: undefined | AsyncValidationState | null;
}>;

export const ValidationProgressState = ({
  validationState,
}: ValidationProgressStateProps) => {
  const { t } = useTranslation('@myn/import-hub');

  return (
    <div className="flex h-full min-h-[400px] w-full flex-col items-center justify-center gap-1 self-stretch rounded bg-ui-primary">
      {validationState ? (
        <>
          <p
            className={cn(
              typographyVariants({ variant: 'caption1', color: 'secondary' }),
            )}
          >
            {t(
              'We have already validated {{processedRows}} rows out of {{totalRows}}',
              {
                processedRows: validationState.processedRows,
                totalRows: validationState.totalRows,
              },
            )}
          </p>
          <ProgressLinear
            value={Math.floor(
              (validationState.processedRows / validationState.totalRows) * 100,
            )}
            className="w-[240px]"
          />
          <p
            className={cn(
              typographyVariants({ variant: 'bodyShort01' }),
              'mt-3',
            )}
          >
            {t(
              'Checking the file for errors. You can leave the page in the meantime!',
            )}
          </p>
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};
